export default __webpack_public_path__ + "static/media/jute-icon.479b8042.svg";